import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=42737f8e&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=42737f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42737f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42737f8e')) {
      api.createRecord('42737f8e', component.options)
    } else {
      api.reload('42737f8e', component.options)
    }
    module.hot.accept("./UsersList.vue?vue&type=template&id=42737f8e&scoped=true&", function () {
      api.rerender('42737f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/UsersList.vue"
export default component.exports